<template>
  <v-container class="pa-0 ma-0">
    <v-expansion-panel :disabled="disabled">
      <slot name="header">
        <v-expansion-panel-header v-slot="{ }" class="pt-0 pb-0 pl-0 pr-4">
          <ParentJobContent :jobItem="JobData" :showStatus="true" :noFLC="true" :previewMode="true">
          </ParentJobContent>
        </v-expansion-panel-header>
      </slot>
      <v-alert v-if="JobData && JobData.FirstLineComment" dense type="warning" icon="mdi-information-variant"
        class="mb-0 pa-0 rounded-b-0" border="left">
        <template v-slot:prepend>
          <div></div>
        </template>
        <area-li :label="$t('servicesystem.common_objects.job.first_line_comment')"
          :value="JobData.FirstLineComment.trim()" :expandonhover="true">
        </area-li>
      </v-alert>

      <v-expansion-panel-content>
        <v-divider />
        <v-container v-if="JobData" class="py-2 px-0">
          <v-row no-gutters v-if="JobData.JobStatus">
            <v-col>
              <edit-li :label="$t('servicesystem.common_objects.job.status')" :value="JobData.JobStatus.Name">
              </edit-li>
            </v-col>
            <v-col v-if="JobData.JobSubStatus">
              <edit-li :label="$t('servicesystem.common_objects.job.substatus')" :value="JobData.JobSubStatus.Name">
              </edit-li>
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col>
              <edit-li :label="$t('servicesystem.common_objects.job.type')" :value="JobData.JobType.Name">
              </edit-li>
            </v-col>
            <v-col>
              <edit-li :label="$t('servicesystem.common_objects.job.priority')" :value="JobData.JobPriority.Name">
              </edit-li>
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col>
              <area-li :label="$t('servicesystem.common_objects.job.order_refrence')" :value="JobData.InvoiceReference">
              </area-li>
            </v-col>
            <v-col>
              <switch-li :label="$t('servicesystem.common_objects.job.notbillable')" :value="JobData.NoInvoice">
              </switch-li>
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col>
              <edit-li :label="$t('servicesystem.common_objects.job.created')"
                :value="i18nFormatDateTime(JobData.CreatedDate)">
              </edit-li>
            </v-col>
            <v-col>
              <edit-li :label="$t('servicesystem.common_objects.job.creator')" :value="JobData.CreatedBy">
              </edit-li>
            </v-col>
          </v-row>
          <FieldPrinter v-if="JobData && AddedFields && AddedFields.JobDetails" :sourceObject="JobData"
            :fieldList="AddedFields.JobDetails" :groupRestriction="'Order'">
          </FieldPrinter>
        </v-container>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-container>
</template>


<script>
import AreaLi from "@/components/Inputs/AreaListItem.vue";
import EditLi from "@/components/Inputs/EditableListItem.vue";
import SwitchLi from "@/components/Inputs/SwitchListItem.vue";
import ParentJobContent from "@/components/ListItems/JobListItem/ParentJobContent.vue";
import moment from "moment";

import FieldPrinter from "@/components/SingleUse/FieldPrinter.vue";

export default {
  name: "ParentJobPreview",
  props: {
    JobData: Object,
  },
  components: {
    EditLi,
    AreaLi,
    SwitchLi,
    ParentJobContent,
    FieldPrinter,
  },

  data: () => ({
    disabled: false,
  }),

  mounted() {},

  methods: {
    toDateString(dt) {
      return moment(dt).format("LL");
    },

    toTimeString(dt) {
      return moment(dt).format("LT");
    },
  },

  computed: {},

  watch: {},
};
</script>